import React, { Component } from "react";
import "./App.css";
import FirstPage from "./FirstPage";
import Navbar from "./Navbar";
import Services from "./Services";
// import '../node_module'
import ThirdPage from "./ThirdPage";
import PageFourth from "./PageFourth";
import ReactDom from "react-dom";
import Icon from './icon';

class App extends Component {
  handleClick = menu => {
    const x = ReactDom.findDOMNode(this.refs[menu]);
    x.scrollIntoView({block: 'start', behavior: "smooth" });
  };
  render() {
    return (
      <div ref="home" className="App">
        <Navbar refss={this.handleClick} />
        <div onClick={() => this.handleClick('home')} className="scroll-top">
          <Icon icon="fa-chevron-circle-up" />
          Top
        </div>

        <div className="header-overlay">
          <h1 className="brand-name">Saichaa Broadband</h1>
        </div>
        <div ref="gallery">
          <FirstPage />
        </div>
        <div ref="services">
          <Services />
        </div>

        <div ref="plans">
        <ThirdPage />
        </div>

        <div ref="about">
        <PageFourth />
        </div>
        
        <div className="padding-vert" />
      </div>
    );
  }
}

export default App;
